import _ from 'lodash';

import {IframeFeaturePoliciesEnum} from '../../../libs/shared/core/src/helpers/browser/browserHelpers';
import {tryParseUrl} from '../../../libs/shared/core/src/helpers/browser/urlHelpers';
import {allowedProtocols} from '../../../libs/shared/core/src/models/helpers/navigationHelpers';
import {ApplicationError} from '../../applications/bridge/v2/types/bridgeTypesV2';
import {ApplicationEntryPointActionFeaturesEnum} from '../../models/api/applicationEntryPointActionModel';
import {ApplicationEntryPointModel} from '../../models/api/applicationEntryPointModel';
import {ApplicationModel} from '../../models/api/applicationModel';

/*
 * Constants.
 */

const applicationFeaturesToIframeFeaturePoliciesMap: {
  [K in ApplicationEntryPointActionFeaturesEnum]?: ReadonlyArray<IframeFeaturePoliciesEnum>;
} = {
  [ApplicationEntryPointActionFeaturesEnum.DEVICE_CAMERA]: [IframeFeaturePoliciesEnum.CAMERA],
  [ApplicationEntryPointActionFeaturesEnum.DEVICE_FULLSCREEN]: [IframeFeaturePoliciesEnum.FULLSCREEN],
  [ApplicationEntryPointActionFeaturesEnum.DEVICE_MICROPHONE]: [IframeFeaturePoliciesEnum.MICROPHONE],
  [ApplicationEntryPointActionFeaturesEnum.DEVICE_CLIPBOARD]: [
    IframeFeaturePoliciesEnum.CLIPBOARD_READ,
    IframeFeaturePoliciesEnum.CLIPBOARD_WRITE,
  ],
  [ApplicationEntryPointActionFeaturesEnum.DISPLAY_CAPTURE]: [IframeFeaturePoliciesEnum.DISPLAY_CAPTURE],
};

export const appIframePermissions = [
  // Allows the content to be treated as being from its normal origin.
  'allow-same-origin',
  // Allows the embedded browsing context to run javascript.
  'allow-scripts',
  // Allows forms to be submitted.
  'allow-forms',
  // Allows window to be open. The window will inherit the sandbox permissions.
  'allow-popups',
  // Allows usage of the Storage Access API.
  'allow-storage-access-by-user-activation',
].join(' ');

/*
 * Helpers.
 */

export function buildAppIframeFeaturePolicies(applicationEntryPoint: ApplicationEntryPointModel) {
  return _(applicationEntryPoint.action?.features)
    .map((f) => applicationFeaturesToIframeFeaturePoliciesMap[f])
    .compact()
    .flatten()
    .uniq()
    .value();
}

export function findApplicationAbsoluteUrl(application: ApplicationModel, urlOrPath: string) {
  // If the URL provided is already an absolute URL, return it.
  const absoluteUrl = tryParseUrl(urlOrPath);
  if (absoluteUrl) {
    if (!allowedProtocols.includes(absoluteUrl.protocol)) {
      throw new Error('This protocol is not allowed');
    }
    return absoluteUrl.href;
  }
  throw new ApplicationError('Invalid URL.');
}
